import React from 'react'

export function Error404() {
  return (
    <div><p>Error404</p></div>
  )
}
